import React from "react";
import './_static/Buttons.css';

function AddVersionButton(props) {

    return (
        // <div className="mb-3">
        <button type="button" className="btn btn-outline-primary btn-md bigButton" style={{"opacity": "0.8"}} onClick={props.addVersion}>
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor"
                 className="bi bi-plus-lg buttonImage" viewBox="0 0 16 16">
                <path fillRule="evenodd"
                      d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2Z"/>
            </svg>Pridať
        </button >
        // </div>
    )
}

export default AddVersionButton
